import { StatisticCardConfig } from '@ms/shared-components';
import { mockVisualData } from './mockData';

// 统计数据配置
export const createStatisticData = (): StatisticCardConfig[] => [
  {
    key: 'total',
    title: '总空间数',
    value: mockVisualData.statistics.totalSpaces,
    iconKey: 'AppstoreOutlined',
    valueStyle: { color: '#1890ff' }
  },
  {
    key: 'occupied',
    title: '已占用',
    value: mockVisualData.statistics.occupiedSpaces,
    iconKey: 'CheckCircleOutlined',
    valueStyle: { color: '#52c41a' }
  },
  {
    key: 'available',
    title: '可用空间',
    value: mockVisualData.statistics.availableSpaces,
    iconKey: 'ExclamationCircleOutlined',
    valueStyle: { color: '#faad14' }
  },
  {
    key: 'utilization',
    title: '利用率',
    value: `${mockVisualData.statistics.utilizationRate}%`,
    iconKey: 'RiseOutlined',
    valueStyle: { color: '#722ed1' }
  }
];
